import { render } from "./AlarmsView.vue?vue&type=template&id=2ea7dc6c"
import script from "./AlarmsView.vue?vue&type=script&lang=js"
export * from "./AlarmsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__